import { createWebHistory, createRouter } from "vue-router"
import posthog from "posthog-js"
import LandingPage from "../src/components/LandingPage.vue"
import SelectedLocations from "../src/components/SelectedLocations.vue"
import TextImprovement from "../src/components/TextImprovement.vue"
import KnowledgeBase from "../src/components/knowledgebase/KnowledgeBase.vue"
import ChatHub from "../src/components/chatbot/ChatHub.vue"
import ChatSubjectInput from "../src/components/chatbot/ChatSubjectInput.vue"
import ChatSession from "../src/components/chatbot/ChatSession.vue"
import ChatSummary from "../src/components/chatbot/ChatSummary.vue"
import ChatHistory from "../src/components/chatbot/ChatHistory.vue"
import LoginForm from "../src/components/LoginForm.vue"
import RegisterForm from "../src/components/RegisterForm.vue"
import UserProfile from "../src/components/userprofile/UserProfile.vue"
import UpdatePasswordVerification from "../src/components/UpdatePasswordVerification.vue"
import { authorizeToken } from "./guards.js"
import SubjectsList from "@/components/knowledgebase/SubjectsList.vue"
import VocabularyList from "@/components/flashcards/VocabularyList.vue"
import VocabularyReview from "@/components/flashcards/VocabularyReview.vue"
import ResourceReader from "@/components/knowledgebase/ResourceReader.vue"
import TermsOfUse from "@/components/TermsOfUse.vue"
import PageNotFound from "@/components/PageNotFound.vue"


const links = [
    {
        path: "/",
        name: "LandingPage",
        component: LandingPage,
        meta: { 
            requireAuth: false
        },
    },
    {
        path: "/login",     
        name: "LoginForm",     
        component: LoginForm,
        props: true,
        meta: { 
            title: 'ImmersiveLang - イマーシブラング',
            icon: `${process.env.BASE_URL}media/watercolor_logo.png`,
         },
    },
    {
        path: "/password",     
        name: "UpdatePasswordForm",     
        component: UpdatePasswordVerification,
        meta: {
            requireAuth: false
        }
    },
    {
        path: "/register",     
        name: "RegisterForm",     
        component: RegisterForm,
        meta: {
            requireAuth: false
        }
    },
    {
        path: "/userprofile",     
        name: "Profile",     
        component: UserProfile,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/selectedlocations",     
        name: "SelectedLocations",     
        component: SelectedLocations,
    },
    {
        path: "/chat",
        name: "ChatHub",
        component: ChatHub,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/chat/new",
        name: "ChatSubjectInput",
        component: ChatSubjectInput,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/chat/session",
        name: "ChatSession",
        component: ChatSession,
        props: true,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/chat/summary/:sessionId",
        name: "ChatSummary",
        component: ChatSummary,
        props: true,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/chat/history",
        name: "ChatHistory",
        component: ChatHistory,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/subjectslist",     
        name: "SubjectsList",     
        component: SubjectsList,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/knowledgebase",     
        name: "KnowledgeBase",     
        component: KnowledgeBase,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/vocabularylist",     
        name: "VocabularyList",     
        component: VocabularyList,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/vocabularyreview",     
        name: "VocabularyReview",     
        component: VocabularyReview,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/reader",
        name: "ResourceReader",
        component: ResourceReader,
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/terms-of-use",
        name: "TermsOfUse",
        component: TermsOfUse,
        meta: {
            requireAuth: false
        }
    },
    {
        path : "/:pathMatch(.*)*",
        component: PageNotFound,
        meta: {
            requireAuth: true
        }
    }
]


const router = createRouter({   
    history: createWebHistory(),  
    routes: links, 
}) 
router.beforeEach(authorizeToken)
router.beforeEach((to, from) => {
  const title = to.meta?.title ?? 'ImmersiveLang - イマーシブラング'
  document.title = title
  let ogTitle = document.querySelector('meta[property="og:title"]')
  if (!ogTitle) {
    ogTitle = document.createElement('meta')
    ogTitle.setAttribute('property', 'og:title')
    document.head.appendChild(ogTitle)
  }
  ogTitle.setAttribute('content', title)
})
router.afterEach((to) => {
  posthog.capture('$pageview', { path: to.fullPath })
})
export default router